import styled from 'styled-components';

import { mediaQueryDesktopMin } from 'styles';

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 0 auto;
  padding: 0 16px;
  width: 100%;

  @media all and ${mediaQueryDesktopMin} {
    max-width: 1292px;
    padding: 0 16px;
  }
`;

export default Wrapper;
